import { useMutation } from '@betterment/js-runtime';
import { Box, CloseButton, useTheme } from '@betterment/style-closet-react';
import { MarginProps } from 'styled-system';

import { urlBuilder } from '../../../Shared/urlBuilder';
import { AccountTask } from '../../data';

interface SkipButtonProps {
  taskName: string;
  onSkip?: () => void;
}

const SkipButton: React.FC<React.PropsWithChildren<SkipButtonProps>> = ({ taskName, onSkip }) => {
  const [skipTask] = useMutation<unknown, { name: string }>(urlBuilder.postSkipTask());

  const closeHandler = async () => {
    await skipTask({ name: taskName });
    onSkip?.();
  };

  return <CloseButton closeHandler={closeHandler} />;
};

interface IndividualTaskContainerProps extends AccountTask, MarginProps, Pick<SkipButtonProps, 'onSkip'> {}

const IndividualTaskContainer: React.FC<React.PropsWithChildren<IndividualTaskContainerProps>> = ({
  name,
  isSkippable,
  onSkip,
  children,
  ...marginProps
}) => {
  const { theme } = useTheme();

  return (
    <Box
      position="relative"
      bg="bmtWhite"
      px={[6, 6, 8]}
      py="8"
      {...marginProps}
      borderBottom="1px solid"
      borderColor="bmtGrey20"
      borderRadius={theme.space[1]}
    >
      {isSkippable && <SkipButton taskName={name} onSkip={onSkip} />}
      {children}
    </Box>
  );
};

export default IndividualTaskContainer;
